import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Response_Processing from "../../../layout/Others/Response_Processing";
import JoditEditor from "jodit-react";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { toast } from "react-toastify";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import AdminCheckBox from "../../../components/CommonComponents/AdminCheckBox";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import stripe_image from "../../../components/Images/payment_logo/stripe.svg";
import paypal_image from "../../../components/Images/payment_logo/paypal.svg";
import razorpay_image from "../../../components/Images/payment_logo/razorpay.svg";
import applepay_image from "../../../components/Images/payment_logo/applepay.svg";
import googlepay_image from "../../../components/Images/payment_logo/googlepay.svg";
import iyzico_image from "../../../components/Images/payment_logo/iyzico.svg";
import pesapal_image from "../../../components/Images/payment_logo/pesapal.svg";
import payhere_image from "../../../components/Images/payment_logo/PayHere.svg";
import cashfree_image from "../../../components/Images/payment_logo/cashfree.svg";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import { IoMdInformationCircle } from "react-icons/io";

const AddAdsPlan = (props) => {

  const { fetchRequest } = useMyContext()

  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_Baseurl
  const headers = getItemToken('access_token')
  const { id } = useParams()
  const labelSource = 'ads-subscription-plan'

  const createApi = `${baseURL}/admin/advertisement/plans-create`
  const previewApi = `${baseURL}/admin/advertisement/plans-edit/${id}`
  const updateApi = `${baseURL}/admin/advertisement/plans-update/${id}`
  const addApi = `${baseURL}/admin/advertisement/plans-store`
  const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`

  const combinedRef = useRef({
    subscription_plan_name: null,
    subscription_plan_price: null,
    ios_plan_price: null,
    ios_product_id: null,
    Ads_upload_count_limit: null,
    Ads_views_count_limit: null,
    billing_interval: null,
    plan_content: null
  });

  const [formData, setFormData] = useState({
    state: "formData",
    user_id: localStorage.getItem("user_id"),
    subscription_plan_name: "",
    subscription_plan_price: "",
    ios_plan_price: "",
    ios_product_id: "",
    status: 1,
    Ads_upload_count_limit: "",
    Ads_views_count_limit: "",
    billing_interval: "monthly",
    billing_type: "Non-Refundable",
    payment_type: "recurring",
    PaymentGateway_id: "",
    plan_content: "",
    stripe_enable: 0,
    iyzico_enable: 0,
    razorpay_enable: 0,
    paypal_enable: 0,
    pesapal_enable: 0,
    payhere_enable: 0,
    cashfree_enable: 0,
    applepay_enable: 0,
    googlepay_enable: 0
  })

  const [defaultOption, setDefaultOption] = useState({
    state: "defaultOption",
    devicesOption: [],
    paymentOption: [],
    intervalOption: []
  })

  const [labelDisplay, setLabelDisplay] = useState([]);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false);
  const [formDataError, setFormDataError] = useState({})
  const [symbol, setSymbol] = useState("");
  const [allPaymentGatewayPlans, setAllPaymentGatewayPlans] = useState([]); // Store all plans with same group_plan_id

  const imageFind = {
    1: stripe_image,
    2: paypal_image,
    3: razorpay_image,
    4: iyzico_image,
    5: applepay_image,
    6: pesapal_image,
    7: payhere_image,
    8: cashfree_image,
    9: googlepay_image,
  }

  const handleInput = (e) => {
    const { name, value, type, checked, id } = e.target;

    if (type === "checkbox") {
      if (name === "devices") {
        let deviceIds = (formData?.devices || "")
          .split(",")
          .filter((val) => val);
        const index = deviceIds.findIndex((val) => val === id.toString());
        if (index !== -1) {
          deviceIds.splice(index, 1);
        } else {
          deviceIds.push(id.toString());
        }
        const devices = deviceIds.length > 0 ? deviceIds.join(",") : "";
        setFormData({ ...formData, devices });
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          devices: "",
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          [name]: checked ? 1 : 0,
        }));
      }
    }

    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }

    if (type === "number") {
      const cleanedValue = value.replace(/[^0-9.-]/g, '');
      let finalValue = cleanedValue === "" ? null : Number(cleanedValue);
      if (isNaN(finalValue)) {
        finalValue = null;
      }
      setFormData((prev) => ({
        ...prev,
        [name]: finalValue
      }));
      if (!finalValue && finalValue !== 0) {
        setFormDataError((prev) => ({
          ...prev,
          [name]: 'This field is required and should contain a valid number.',
        }));
      } else {
        setFormDataError((prev) => ({
          ...prev,
          [name]: '',
        }));
      }
    }

    if (type === 'text') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  const labelFetch = async () => {
    try {
      setShowOverlay(true)
      const response = await axios.get(`${labelApi}`, { headers: headers });
      const result = response?.data?.label_management
      setLabelDisplay(result)
      setShowOverlay(false)
    }
    catch (err) {
      setShowOverlay(false)
      toast.error(err.response.data.message)
    }
  }

  const FetchCurrency = async () => {
    const currencyDefault = `${baseURL}/admin/currency_setting/index`
    const response = await axios.get(`${currencyDefault}`, { headers: headers, })
      .then((response) => {
        var result = response?.data?.CurrencySetting?.symbol;
        setSymbol(result);
      })
      .catch((error) => console.log(error));
  }

  const create = async () => {
    try {
      setWithOutRefresh(prev => !prev)
      setShowOverlay(true)
      const response = await axios.get(createApi, { headers })
      const responseData = response?.data

      if (responseData?.status) {
        const intervalOptions = [
          { name: "Monthly", value: "monthly" },
          { name: "Yearly", value: "yearly" },
          { name: "Weekly", value: "weekly" }
        ];

        // Map payment settings dynamically by type to avoid index issues
        const paymentMap = {};
        responseData?.PaymentGatewaysLists?.forEach(payment => {
          if (payment?.type) {
            paymentMap[payment.type] = payment.status || 0;
          }
        });

        setFormData((prev) => ({
          ...prev,
          stripe_enable: paymentMap['stripe_enable'] || 0,
          paypal_enable: paymentMap['paypal_enable'] || 0,
          razorpay_enable: paymentMap['razorpay_enable'] || 0,
          iyzico_enable: paymentMap['iyzico_enable'] || 0,
          pesapal_enable: paymentMap['pesapal_enable'] || 0,
          payhere_enable: paymentMap['payhere_enable'] || 0,
          cashfree_enable: paymentMap['cashfree_enable'] || 0,
          applepay_enable: paymentMap['applepay_enable'] || 0,
          googlepay_enable: paymentMap['googlepay_enable'] || 0,
        }))

        setDefaultOption((prev) => ({
          ...prev,
          devicesOption: responseData?.devices || [],
          paymentOption: responseData?.PaymentGatewaysLists || [],
          intervalOption: intervalOptions
        }))
        setShowOverlay(false)
      } else {
        throw new Error(responseData?.message || 'Failed to fetch creation data')
      }
    } catch (error) {
      console.error('Create API Error:', error);
      toast.error(error?.response?.data?.message || 'Failed to load form data');
      setShowOverlay(false);
    }
  }

  const previewAdsPlan = async () => {
    try {
      setShowOverlay(true);
      const response = await axios.get(`${previewApi}`, { headers });
      const result = response?.data;
      
      if (result?.status) {
        const planData = result?.Ads_Subscription_Plans;
        const allPlans = result?.All_Payment_Gateway_Plans || [];
        
        console.log('🔍 Debug - Full API Response:', result);
        console.log('📋 Debug - Plan Data:', planData);
        console.log('💳 Debug - All Plans Array:', allPlans);
        console.log('📊 Debug - Plans Count:', allPlans.length);
        
        setFormData((prev) => ({
          ...prev,
          ...planData
        }));
        
        // Store all payment gateway plans for display
        setAllPaymentGatewayPlans(allPlans);
        
        if (allPlans.length > 0) {
          toast.success(`Plan loaded! Found ${allPlans.length} payment gateway(s).`);
        } else {
          toast.success('Plan data loaded successfully!');
        }
      } else {
        toast.error(result?.message || 'Failed to load plan data - Invalid response');
      }
      setShowOverlay(false);
    } catch (error) {
      console.error('💥 Preview API Error:', error);
      console.error('📄 Error Response:', error?.response?.data);
      toast.error(error?.response?.data?.message || 'Failed to load plan data');
      setShowOverlay(false);
    }
  };

  const formValidation = () => {
    let formIsValid = true;

    // If in edit mode (id exists), only validate plan_content
    if (id) {
      const plainTextContent = (formData.plan_content || '').replace(/<[^>]+>/g, '').trim();
      if (plainTextContent.length > 500) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          plan_content: "Plan content must not exceed 500 characters.",
        }));
        if (combinedRef.current['plan_content']) {
          combinedRef.current['plan_content'].focus();
        }
        formIsValid = false;
      }
      return formIsValid;
    }

    // For create mode, validate all fields
    if (!formData?.subscription_plan_name || formData.subscription_plan_name.trim().length < 3) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        subscription_plan_name: formData?.subscription_plan_name
          ? "Plan Name must be at least 3 characters."
          : "Plan Name cannot be empty.",
      }));
      combinedRef.current['subscription_plan_name'].focus()
      formIsValid = false;
    }

    const plainTextContent = formData.plan_content.replace(/<[^>]+>/g, '').trim();

    if (plainTextContent.length > 500) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        plan_content: "Plan content must not exceed 500 characters.",
      }));
      combinedRef.current['plan_content'].focus();
      formIsValid = false;
    }


    if (!formData?.subscription_plan_price) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        subscription_plan_price: "Plan Price cannot be empty.",
      }));
      combinedRef.current['subscription_plan_price'].focus()
      formIsValid = false;
    }

    if (!formData?.Ads_upload_count_limit) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        Ads_upload_count_limit: "Ads Upload Count Limit cannot be empty.",
      }));
      combinedRef.current['Ads_upload_count_limit'].focus()
      formIsValid = false;
    }

    if (!formData?.Ads_views_count_limit) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        Ads_views_count_limit: "Ads Views Count Limit cannot be empty.",
      }));
      combinedRef.current['Ads_views_count_limit'].focus()
      formIsValid = false;
    }

    if (!formData?.billing_interval) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        billing_interval: "Billing Interval cannot be empty.",
      }));
      combinedRef.current['billing_interval'].focus()
      formIsValid = false;
    }
    return formIsValid;
  }

  const handleStore = (e) => {
    e.preventDefault()
    if (formValidation()) {
      if (id) {
        handleUpdate()
      } else {
        handleSubmit()
      }
    }
  }

  const handleSubmit = async () => {
    try {
      setShowOverlay(true)
      alert("⚠️ Price, Billing Interval, and Trial Days cannot be changed once a plan has active subscriptions. To change them, create a new plan.")

      // Generate dynamic plan ID based on plan name and timestamp
      const generatePlanId = () => {
        const planName = formData?.subscription_plan_name || "plan";
        const timestamp = Date.now();
        return `${planName.toLowerCase().replace(/[^a-z0-9]/g, '_')}_${timestamp}`;
      };

      // Get enabled payment gateways that are active (status == 1)
      const getEnabledPaymentGateways = () => {
        return defaultOption?.paymentOption?.filter(gateway => 
          gateway?.status == 1 // Only get gateways that are active/enabled
        ) || [];
      };

      const enabledGateways = getEnabledPaymentGateways();
      console.log('Enabled Payment Gateways:', enabledGateways);

      if (enabledGateways.length === 0) {
        throw new Error('No active payment gateways available');
      }

      // Generate a group plan ID for linking multiple gateway entries
      const groupPlanId = `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      
      // Create array to store all API calls
      const apiCalls = [];

      // Loop through each enabled payment gateway and create a separate plan entry
      enabledGateways.forEach((gateway, index) => {
        const submitData = {
          user_id: localStorage.getItem("user_id"),
          subscription_plan_name: formData?.subscription_plan_name,
          subscription_plan_price: Number(formData?.subscription_plan_price),
          Ads_upload_count_limit: Number(formData?.Ads_upload_count_limit),
          Ads_views_count_limit: Number(formData?.Ads_views_count_limit),
          subscription_plan_id: `${generatePlanId()}_${gateway.type}`, // Unique ID per gateway
          ios_plan_price: formData?.ios_plan_price || null,
          ios_product_id: formData?.ios_product_id || null,
          billing_interval: formData?.billing_interval,
          billing_type: formData?.billing_type,
          payment_type: formData?.payment_type,
          PaymentGateway_id: gateway.id, // Use specific gateway ID
          status: Number(formData?.status),
          plan_content: formData?.plan_content || "",
          group_plan_id: groupPlanId, // Link all entries together
          type: gateway.payment_type || gateway.type, // Payment gateway type
        };

        console.log(`Preparing ${gateway.payment_type || gateway.type} plan data:`, submitData);
        
        // Add API call to the array
        apiCalls.push(
          axios.post(addApi, submitData, { headers })
            .then(response => {
              console.log(`${gateway.payment_type || gateway.type} plan created successfully:`, response.data);
              return { gateway: gateway.payment_type || gateway.type, success: true, data: response.data };
            })
            .catch(error => {
              console.error(`Error creating ${gateway.payment_type || gateway.type} plan:`, error);
              return { gateway: gateway.payment_type || gateway.type, success: false, error: error.response?.data || error.message };
            })
        );
      });

      // Execute all API calls concurrently
      const results = await Promise.all(apiCalls);

      // Check results and show appropriate messages
      const successfulCreations = results.filter(result => result.success);
      const failedCreations = results.filter(result => !result.success);

      console.log('API Results Summary:', {
        total: results.length,
        successful: successfulCreations.length,
        failed: failedCreations.length,
        results: results
      });

      if (successfulCreations.length > 0) {
        const successMessage = `Ads Subscription Plan created successfully for ${successfulCreations.map(r => r.gateway).join(', ')} payment gateway(s).`;
        
        if (failedCreations.length > 0) {
          const failMessage = `Failed to create for ${failedCreations.map(r => r.gateway).join(', ')}.`;
          toast.success(`${successMessage} ${failMessage}`);
        } else {
          toast.success(successMessage);
        }
        
        navigate('/advertisement-subscription-plans');
      } else {
        throw new Error('Failed to create ads subscription plan for any payment gateway');
      }
    } catch (error) {
      console.error('Submit API Error:', error);
      if (error?.response?.data?.errors) {
        const backendErrors = {};
        error.response.data.errors.forEach(err => {
          const field = err.path || err.param;
          backendErrors[field] = err.msg;
        });
        setFormDataError(backendErrors);
      } else {
        toast.error(error?.response?.data?.message || 'Failed to create ads subscription plan');
      }
      setShowOverlay(false);
    }
  }

  const handleUpdate = async () => {
    try {
      setShowOverlay(true);

      const updateData = {
        status: Number(formData?.status),
        plan_content: formData?.plan_content || "",
      };

      const response = await axios({
        method: "PATCH",
        url: updateApi,
        data: updateData,
        headers: headers,
      });

      const result = response?.data;
      if (result?.status) {
        setShowOverlay(false);
        toast.success(result?.message || 'Ads Subscription Plan updated successfully.');
        // Navigate back to listing page after successful update
        setTimeout(() => {
          navigate('/advertisement-subscription-plans');
        }, 1500);
      } else {
        throw new Error(result?.message || 'Failed to update ads subscription plan')
      }
    } catch (error) {
      console.error('Update API Error:', error);
      if (error?.response?.data?.errors) {
        const backendErrors = {};
        error.response.data.errors.forEach(err => {
          const field = err.path || err.param;
          backendErrors[field] = err.msg;
        });
        setFormDataError(backendErrors);
      } else {
        toast.error(error?.response?.data?.message || 'Failed to update ads subscription plan');
      }
      setShowOverlay(false);
    }
  }

  useEffect(async () => {
    await labelFetch()
    await FetchCurrency()
    await create()
  }, [])

  useEffect(async () => {
    if (id) {
      await previewAdsPlan()
    }
  }, [withOutRefresh, id])

  return (
    <>
      <AdminBackNavigation path={`${'/advertisement-subscription-plans'}`} text="Back" />
      {showOverlay && (<Response_Processing />)}
      
      {!id ?
        <>
          <AdminSaveHeader heading={labelDisplay?.[2]?.title || "Add Ads Plan"} saveText={labelDisplay?.[1]?.title || "Save"} saveMethod={handleStore} />
          
          <div className="d-flex align-items-center flex-wrap mb-3">
            {defaultOption?.paymentOption?.map((item) => {
              if (item?.payment_type) {
                return (
                  <div className="col-12 col-md-6 col-lg-4 pe-3 mb-3" key={item.payment_type}>
                    <div className=" d-flex align-items-center justify-content-between  p-3 theme-bg-color rounded-3">
                      <div className="d-flex flex-wrap flex-column">
                        <MessageLabel text={item.payment_type} className={"mb-0 mb-md-0"} />
                        <MessageBox classname={`${item?.payment_mode == 0 ? "text-color-button" : "text-color-button"} fw-bold mt-1`} text={item?.payment_mode == 0 ? "Test mode" : "Live mode"} />
                      </div>
                      <AdminCheckBox name={item?.type} checked={formData?.[item?.type] == 1} disabled readOnly />
                    </div>
                  </div>
                );
              }
              return null;
            })}
          </div>

      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={labelDisplay?.[3]?.title || "Plan Information"} />
            <MessageLabel text={labelDisplay?.[4]?.title || "Plan Name"} className="mandatorySimple" />
            <AdminCustomInput type="text" name="subscription_plan_name" value={formData?.subscription_plan_name} onChange={handleInput} placeHolder={"Plan Name"} ref={(el) => (combinedRef.current.subscription_plan_name = el)} error={formDataError?.subscription_plan_name} />
            
            <MessageLabel text={labelDisplay?.[5]?.title || "Billing Interval"} className="mandatorySimple" />
            <AdminCustomSelect name="billing_interval" value={formData?.billing_interval} onChange={handleInput} ref={(el) => (combinedRef.current.billing_interval = el)} options={defaultOption?.intervalOption?.map((item, index) => ({ name: item?.name, value: item?.value }))} error={formDataError?.billing_interval} defaultOptionName={"Choose an Interval"} />

            <MessageLabel text={labelDisplay?.[6]?.title || "Billing Type"} className="mandatorySimple" />
            <AdminCustomInput type="text" name="billing_type" value={formData?.billing_type} onChange={handleInput} placeHolder={"Billing Type"} readOnly />

            <MessageLabel text={labelDisplay?.[8]?.title || "Plan Content"} />
            <JoditEditor className="mb-3" ref={(el) => (combinedRef.current.plan_content = el)} value={formData?.plan_content} onChange={(newContent) => setFormData(prev => ({ ...prev, plan_content: newContent }))} />
            {formDataError?.plan_content && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.plan_content}`} classname='errorred  d-block' /></div>)}
          </Wrapper>

        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text={labelDisplay?.[12]?.title || "Pricing Information"} />
            <MessageLabel text={`${labelDisplay?.[13]?.title || "Price"} (${symbol})`} className="mandatorySimple" />
            <AdminCustomInput type="number" name="subscription_plan_price" value={formData?.subscription_plan_price} onChange={handleInput} placeHolder="Price" min={1} maxLength={9} ref={(el) => (combinedRef.current.subscription_plan_price = el)} error={formDataError?.subscription_plan_price} restrictNumberInput />
          </Wrapper>

          <Wrapper>
            <div className="card p-3 mt-3">
              <MessageHeading text="Advertisement Limits" />
              <MessageLabel text="Ads Upload Count Limit" className="mandatorySimple" />
              <AdminCustomInput type="number" name="Ads_upload_count_limit" value={formData?.Ads_upload_count_limit} onChange={handleInput} placeHolder={"Enter maximum ads upload limit"} ref={(el) => (combinedRef.current.Ads_upload_count_limit = el)} error={formDataError?.Ads_upload_count_limit} />

              <MessageLabel text="Ads Views Count Limit" className="mandatorySimple" />
              <AdminCustomInput type="number" name="Ads_views_count_limit" value={formData?.Ads_views_count_limit} onChange={handleInput} placeHolder={"Enter maximum ads views limit"} ref={(el) => (combinedRef.current.Ads_views_count_limit = el)} error={formDataError?.Ads_views_count_limit} />
            </div>
          </Wrapper>

          <Wrapper>
            <MessageHeading text={labelDisplay?.[9]?.title || "Plan Settings"} />
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text="Active Status" />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'status'} checked={formData?.status == 1} onChange={handleInput} />
              </div>
            </div>
          </Wrapper>

        </RightWrapper>
          <AdminCustomButton saveMethod={handleStore} type="submit" saveText={"Create Ads Plan"} className="ms-auto" loading={showOverlay} />
        </FormContainer>
        </>
        :
        <>
          <div className="d-flex align-items-center flex-wrap justify-content-between mb-4" >
            <div className="col-12 col-md-8">
              <MessageHeading className="admin-title text-md-start mb-0" text={"Preview & Edit Ads Plan"} noMargin padding />
            </div>
            <div className="col-12 col-md-4 d-flex justify-content-end">
              <AdminCustomButton saveMethod={handleStore} saveText={"Update"} className="" loading={showOverlay} />
            </div>
          </div>

          <Wrapper>
            <MessageHeading text="Plan Details (Preview Only)" />
            <div className="d-flex align-items-center flex-wrap justify-content-between mb-3">
              <div className="col-lg-5 col-md-5 col-sm-5 position-relative">
                <MessageLabel text="Plan Name" className={"fw-bold"} />
              </div>
              <div className="col-lg-1 col-md-1 col-sm-1 position-relative">
                <MessageLabel text=":" className={""} />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 position-relative">
                <MessageSubHeading text={formData?.subscription_plan_name || '-'} className={""} />
              </div>

              {/* Multiple Subscription Plan IDs */}
              {/* {allPaymentGatewayPlans.length > 0 && (
                <>
                  <div className="col-12 mb-3 mt-3">
                    <hr className="my-2" />
                    <MessageLabel text="All Subscription Plan IDs" className={"fw-bold text-primary"} />
                  </div>
                  
                  {allPaymentGatewayPlans.map((plan, index) => (
                    <>
                      <div className="col-lg-5 col-md-5 col-sm-5 position-relative" key={`label-${index}`}>
                        <MessageLabel text={`${plan.payment_gateway_info?.name || `Gateway ${plan.PaymentGateway_id}`} Plan ID`} className={"fw-bold"} />
                      </div>
                      <div className="col-lg-1 col-md-1 col-sm-1 position-relative" key={`colon-${index}`}>
                        <MessageLabel text=":" className={""} />
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 position-relative" key={`value-${index}`}>
                        <div className="d-flex align-items-center">
                          {imageFind[plan.PaymentGateway_id] && (
                            <img 
                              src={imageFind[plan.PaymentGateway_id]} 
                              alt={plan.payment_gateway_info?.name}
                              style={{ width: "20px", height: "15px", marginRight: "8px" }}
                            />
                          )}
                          <MessageSubHeading text={plan.subscription_plan_id} className={"text-break"} />
                        </div>
                      </div>
                    </>
                  ))}
                </>
              )} */}
              
              <div className="col-lg-5 col-md-5 col-sm-5 position-relative">
                <MessageLabel text="Price" className={"fw-bold"} />
              </div>
              <div className="col-lg-1 col-md-1 col-sm-1 position-relative">
                <MessageLabel text=":" className={""} />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 position-relative">
                <MessageSubHeading text={formData?.subscription_plan_price ? `${symbol}${formData.subscription_plan_price}` : '-'} className={""} />
              </div>
              
              <div className="col-lg-5 col-md-5 col-sm-5 position-relative">
                <MessageLabel text="Billing Interval" className={"fw-bold"} />
              </div>
              <div className="col-lg-1 col-md-1 col-sm-1 position-relative">
                <MessageLabel text=":" className={""} />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 position-relative">
                <MessageSubHeading text={formData?.billing_interval ? formData.billing_interval.charAt(0).toUpperCase() + formData.billing_interval.slice(1) : '-'} className={""} />
              </div>

              <div className="col-lg-5 col-md-5 col-sm-5 position-relative">
                <MessageLabel text="Billing Type" className={"fw-bold"} />
              </div>
              <div className="col-lg-1 col-md-1 col-sm-1 position-relative">
                <MessageLabel text=":" className={""} />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 position-relative">
                <MessageSubHeading text={formData?.billing_type || '-'} className={""} />
              </div>

              <div className="col-lg-5 col-md-5 col-sm-5 position-relative">
                <MessageLabel text="Payment Type" className={"fw-bold"} />
              </div>
              <div className="col-lg-1 col-md-1 col-sm-1 position-relative">
                <MessageLabel text=":" className={""} />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 position-relative">
                <MessageSubHeading text={formData?.payment_type || '-'} className={""} />
              </div>
              
              <div className="col-lg-5 col-md-5 col-sm-5 position-relative">
                <MessageLabel text="Ads Upload Limit" className={"fw-bold"} />
              </div>
              <div className="col-lg-1 col-md-1 col-sm-1 position-relative">
                <MessageLabel text=":" className={""} />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 position-relative">
                <MessageSubHeading text={formData?.Ads_upload_count_limit || '-'} className={""} />
              </div>
              
              <div className="col-lg-5 col-md-5 col-sm-5 position-relative">
                <MessageLabel text="Ads Views Limit" className={"fw-bold"} />
              </div>
              <div className="col-lg-1 col-md-1 col-sm-1 position-relative">
                <MessageLabel text=":" className={""} />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 position-relative">
                <MessageSubHeading text={formData?.Ads_views_count_limit || '-'} className={""} />
              </div>
            </div>
          </Wrapper>

          {/* Multiple Payment Gateways Section */}
          {allPaymentGatewayPlans.length > 0 && (
            <Wrapper>
              <MessageHeading text="Payment Gateway Plans" className="mb-3" />
              <div className="row">
                {allPaymentGatewayPlans.map((plan, index) => (
                  <div key={index} className="col-lg-6 col-md-6 col-sm-12 mb-3">
                    <div className="card p-3 border">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center">
                          {imageFind[plan.PaymentGateway_id] && (
                            <img 
                              src={imageFind[plan.PaymentGateway_id]} 
                              alt={plan.payment_gateway_info?.name || `Gateway ${plan.PaymentGateway_id}`}
                              style={{ width: "40px", height: "30px", marginRight: "10px" }}
                            />
                          )}
                          <div>
                            <MessageLabel text={plan.payment_gateway_info?.name || `Gateway ${plan.PaymentGateway_id}`} className="fw-bold mb-1" />
                            <MessageBox text={`Gateway ID: ${plan.PaymentGateway_id}`} classname="text-muted small" />
                          </div>
                        </div>
                        <span className={`badge ${plan.status == 1 ? 'bg-success' : 'bg-secondary'}`}>
                          {plan.status == 1 ? 'Active' : 'Inactive'}
                        </span>
                      </div>
                      <div className="plan-details">
                        <MessageBox text={`Plan ID: ${plan.subscription_plan_id}`} classname="text-break small text-muted mb-1" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Wrapper>
          )}

          <FormContainer>
            <LeftWrapper>
              <Wrapper>
                <div className="card p-3 shadow-sm">
                  <MessageHeading text="Plan Content" className="text-primary" />
                  <JoditEditor className="mb-3" ref={(el) => (combinedRef.current.plan_content = el)} value={formData?.plan_content} onChange={(newContent) => setFormData(prev => ({ ...prev, plan_content: newContent }))} />
                  {formDataError?.plan_content && (<div className='d-flex align-items-center gap-1 mb-2'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${formDataError?.plan_content}`} classname='errorred  d-block' /></div>)}
                </div>
              </Wrapper>
            </LeftWrapper>
            
            <RightWrapper>
              <Wrapper>
                <div className="card p-3 shadow-sm">
                  <MessageHeading text="Plan Status" className="text-primary" />
                  <div className="d-flex justify-content-between mb-2 ">
                    <div className="col-6 col-md-6 pe-2">
                      <MessageLabel text="Active Status" className="fw-bold" />
                    </div>
                    <div className="col-6 col-md-6 ps-2 text-end">
                      <AdminSwitch name={'status'} checked={formData?.status == 1} onChange={handleInput} />
                    </div>
                  </div>
                  <MessageBox text={formData?.status == 1 ? "Plan is currently Active" : "Plan is currently Inactive"} classname={`${formData?.status == 1 ? 'text-success' : 'text-danger'} small mt-2`} />
                </div>

                <div className="d-flex justify-content-end mt-3">
                  <AdminCustomButton saveMethod={handleStore} saveText={"Update Plan"} className="btn-lg" loading={showOverlay} />
                </div>
              </Wrapper>
            </RightWrapper>
          </FormContainer>
        </>
      }
    </>
  );
};

export default AddAdsPlan;